import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import CreateDap from "@/pages/CreateDap";
import DapDetail from "@/pages/DapDetail";
import Ledger from "@/pages/Ledger";
import Directory from "@/pages/Directory";
import Settings from "@/pages/Settings";
import Admin from "@/pages/Admin";
import ShareView from "@/pages/ShareView";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Layout from "@/components/Layout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-[#5C5A54]">
        <span className="font-serif-dl text-2xl">Opening the ledger…</span>
      </div>
    );
  if (!user) {
    const intended = location.pathname + location.search;
    if (intended && intended !== "/dashboard") {
      sessionStorage.setItem("dap_redirect", intended);
    }
    return <Navigate to="/" replace />;
  }
  return <Layout>{children}</Layout>;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/s/:token" element={<ShareView />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/create" element={<Protected><CreateDap /></Protected>} />
      <Route path="/dap/:id" element={<Protected><DapDetail /></Protected>} />
      <Route path="/ledger" element={<Protected><Ledger /></Protected>} />
      <Route path="/directory" element={<Protected><Directory /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
